var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'chart-container-tab': _vm.chartLayout === '4tab',
    'chart-container': true,
    'selected-tab': (_vm.selectedTab === _vm.chartIndex && _vm.chartLayout != '1tab' && !_vm.isFullScreen),
    'chart-tab': _vm.selectedTab !== _vm.chartIndex
},on:{"click":function($event){!_vm.isTrainingMode && _vm.selectTab(_vm.chartIndex)}}},[(_vm.showLoader)?_c('Loader',{attrs:{"showLoader":_vm.showLoader}}):_vm._e(),(_vm.showChart)?_c('Chart',{attrs:{"chartIndex":_vm.chartIndex,"chartHeightTemp":_vm.chartHeightTemp,"chartWidthTemp":_vm.chartWidthTemp,"chartSymbolTitle":_vm.chartSymbolTitle,"chartOHLCV":_vm.chartOHLCV}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }